import React from 'react';

import {
  Disclosure,
  DisclosureButton,
  DisclosurePanel,
} from '@headlessui/react';
import Icon from '@components/utils/IconWrap';

export default function NavDisclosure({
  label = 'Product',
  buttonClassName = 'group',
  children,
}) {
  return (
    <Disclosure as="div" className="-mx-3">
      <DisclosureButton
        className={`flex w-full items-center justify-between rounded-lg py-2 pl-3 pr-3.5 text-base/7 font-semibold text-base-content hover:bg-base-100 ${buttonClassName}`}
      >
        {label}
        <Icon
          icon="mdi:chevron-down"
          aria-hidden="true"
          className="w-5 group-data-[open]:rotate-180 transition-transform duration-200"
        />
      </DisclosureButton>
      <DisclosurePanel className="mt-2 space-y-2 relative z-[60] origin-bottom transition duration-500 ease-out group-data-[open]:translate-y-0 group-data-[closed]:-translate-y-6 group-data-[closed]:opacity-0">
        {children}
      </DisclosurePanel>
    </Disclosure>
  );
}
